export default {
  product: {
    title: 'Product FIFO checker',

    general: {
      table: {
        header: {
          row: 'Row',
          image: 'Image',
          barcode: ' Barcode',
          name: 'Name',
          source: 'Source',
          count: 'QTY',
          destination: 'Destination',
          date: 'Date'
        }
      },

      tabs: {
        inventoryMovement: 'Inventory movement',
        purchaseLot: 'Purchase lot',
        saleCostAllocation: 'Sale cost allocation',
        saleReturnAllocation: 'Sale refund allocation'
      }
    },

    inventoryMovement: {
      general: {
        table: {
          header: {
            row: 'Row',
            image: 'Image',
            barcode: ' Barcode',
            name: 'Name',
            storeroom: 'Warehouse',
            movementType: 'Movement type',
            reference: 'Reference',
            referenceLineId: 'Line Id',
            count: 'QTY',
            unitCost: 'Unit cost',
            totalCost: 'Total cost',
            reversalMovementId: 'Reversal movement id',
            date: 'Date'
          }
        },

        movementTypes: {
          purchase: 'Purchase',
          purchase_return: 'Purchase refund',
          sale: 'Sale',
          sale_return: 'Sale refund',
          transfer_in: 'Transfer in',
          transfer_out: 'Transfer out',
          conversion_in: 'Conversion in',
          conversion_out: 'Conversion out',
          opening_balance: 'Opening balance',
          adjustment_decrease: 'Adjustment decrease',
          adjustment_increase: 'Adjustment increase'
        }
      }
    },

    saleCostAllocation: {
      general: {
        table: {
          header: {
            row: 'Row',
            image: 'Image',
            barcode: ' Barcode',
            name: 'Name',
            purchaseLotId: 'Purchase lot id',
            reference: 'Reference',
            referenceLineId: 'Line Id',
            allocatedCount: 'Allocated QTY',
            unitCost: 'Unit cost',
            totalCost: 'Total cost',
            reversedAt: 'Reversed at',
            date: 'Date'
          }
        }
      }
    },

    saleReturnAllocation: {
      general: {
        table: {
          header: {
            row: 'Row',
            image: 'Image',
            barcode: ' Barcode',
            name: 'Name',
            purchaseLotId: 'Purchase lot id',
            reference: 'Reference',
            referenceLineId: 'Line Id',
            returnedCount: 'Refunded QTY',
            unitCost: 'Unit cost',
            totalCost: 'Total cost',
            date: 'Date'
          }
        }
      }
    },

    purchaseLot: {
      general: {
        table: {
          header: {
            row: 'Row',
            image: 'Image',
            barcode: ' Barcode',
            name: 'Name',
            storeroom: 'Warehouse',
            originId: 'Origin id',
            lotSequence: 'Lot sequence',
            reference: 'Reference',
            referenceLineId: 'Line Id',
            orginalCount: 'Orginal QTY',
            remainingCount: 'Remaining QTY',
            unitCost: 'Unit cost',
            status: 'Status',
            date: 'Date'
          }
        },

        status: {
          active: 'Active',
          consumed: 'Consumed',
          cancelled: 'Cancelled'
        }
      }
    }
  }
}
